import { Injectable } from '@angular/core';
import { PKCEEncoderService } from './p-k-c-e-encoder.service';
import { PKCEVerifierStorageService } from './p-k-c-e-verifier-storage.service';
import { ArrayBufferToBinaryStringConversionService } from 'src/app/shared/convert/services/array-buffer-to-binary-string-conversion.service';
import { BinaryStringToArrayBufferConversionServiceService } from 'src/app/shared/convert/services/binary-string-to-array-buffer-conversion-service.service';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class PKCEVerifierService {
  constructor(private arrayBufferToBinaryStringConversionService: ArrayBufferToBinaryStringConversionService,
    private stringToArrayBufferService: BinaryStringToArrayBufferConversionServiceService,
    private pkceEncoderService: PKCEEncoderService,
    private verifierStorageService: PKCEVerifierStorageService) { }

  generateVerifier() {
    const randomBytes = crypto.getRandomValues(new Uint8Array(32));
    const binaryString = this.arrayBufferToBinaryString(randomBytes.buffer);
    return this.pkceEncode(binaryString);
  }

  pkceEncode(str) {
    return this.pkceEncoderService.encode(str);
  }

  storeVerifier(verifier) {
    this.verifierStorageService.storeVerifier(verifier);
  }

  loadVerifier() {
    return this.verifierStorageService.loadVerifier();
  }

  arrayBufferToBinaryString(buffer) {
    return this.arrayBufferToBinaryStringConversionService.run(buffer);
  }

  stringToArrayBuffer(str) {
    return this.stringToArrayBufferService.run(str);
  }
}
